module.exports = __webpack_public_path__ + "static/media/icecek1.48a3137a.png";